// This file containes functions specific to custom, non-cms, pages, such as the global commitment data pages.

import { compareObjectIndices, hasValidIndex } from './helper-functions';

// This function merges CMS Sub Pages with Custom Sub Pages defined in .json files
// If the Custom Sub Pages contain an optional index, they will be inserted at that point in the array 👾
export const mergeSubPages = (subPages, customSubPages, localeCode) => {
  let mergedSubPages = [];
  if (Array.isArray(subPages)) {
    subPages.forEach(subPage => {
      if (subPage.enabled === true && subPage.node_locale === localeCode) {
        mergedSubPages.push(subPage);
      }
    });
  }
  if (Array.isArray(customSubPages)) {
    customSubPages.sort(compareObjectIndices).forEach(customSubPage => {
      if (hasValidIndex(customSubPage)) {
        mergedSubPages.splice(customSubPage.index, 0, customSubPage);
      } else {
        mergedSubPages.push(customSubPage);
      }
    });
  }
  if (!Array.isArray(subPages) || !Array.isArray(customSubPages)) {
    console.warn(
      `Warning in custom-page-functions.js -> mergeSubPages. Function received unexpected arguments, subPages: ${subPages}, customSubPages: ${customSubPages}`
    );
  }

  return mergedSubPages;
};
